import { render, staticRenderFns } from "./Leftnav.vue?vue&type=template&id=83b205d8&scoped=true"
import script from "./Leftnav.vue?vue&type=script&lang=js"
export * from "./Leftnav.vue?vue&type=script&lang=js"
import style0 from "./Leftnav.vue?vue&type=style&index=0&id=83b205d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b205d8",
  null
  
)

export default component.exports